<template>
  <header id="header" class="container-fluid header">
    <div class="container">
      <div class="row justify-content-between">
        <div class="header-logo-wrapper col-auto">
          <router-link to="/" class="header-logo-link">
            <img
              class="header-logo-link-img"
              src="/images/main_logo.png"
              alt="EcoSpark Electrical Ltd Logo"
            />
          </router-link>
        </div>
        <div class="header-navigation-wrapper col-auto">
          <MobileMenu></MobileMenu>
          <ul class="header-navigation-items">
            <li>
              <router-link class="header-navigation-items-link" to="/our-services/">
                Our Services
              </router-link>
            </li>
            <li>
              <router-link class="header-navigation-items-link" to="/about-us/">
                About Us
              </router-link>
            </li>
            <li>
              <router-link
                class="header-navigation-items-link"
                to="/contact-us/"
              >
                Contact Us
              </router-link>
            </li>
            <li>
              <a href="tel:07956062222" class="btn">07956062222</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import MobileMenu from '@/components/partials/MobileMenu'

export default {
  name: 'main-header',
  components: {
    MobileMenu
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables/colors";
@import "../../assets/styles/variables/breakpoints";

.header {
  background-color: $clr-theme-black;
  border-bottom: solid 8px #013F26;

  .router-link-active {
    text-decoration: underline;
    text-decoration-color: $clr-theme-red;
    color: $white;
  }

  .btn {
    font-size: 16px;
    color: #FCFCFC;

    &:hover {
      background-color: $secondary;
    }
  }

  padding: 18px 0;

  &-logo-link-img {
    max-width: 90px;
    max-height: 180px;
    @media screen and (min-width: $md-breakpoint) {
      max-width: 120px;
    }
  }

  &-navigation {
    &-wrapper {
      margin: 0;

      @media screen and (min-width: $lg-breakpoint) {
        margin: auto 0;
      }
    }

    &-items {
      margin: 0;
      padding: 0;
      font-size: 16px;
      list-style-type: none;
      display: none;
      justify-content: space-between;
      align-items: center;

      > li + li {
        margin-left: 2rem;
      }

      @media screen and (min-width: $lg-breakpoint) {
        display: flex;
      }

      &-link {
        font-weight: 700;
        color: $white;
        text-transform: uppercase;

        &:hover {
          color: $white;
          text-decoration-color: $clr-theme-red;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/MainHeader.vue